function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef } from "react";
import uuid from "uuid/v4";
import PropTypes from "prop-types";
import Loading from "../elements/loading";
import TableRow from "./table-row";
import classNames from "classnames";
import Pagination from "../forms/pagination";
import EmptyStateMessage from "../elements/empty-state-message";
import useInfiniteScroll from "../../hooks/use-infinite-scroll";

var Table = function Table(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      caption = _ref.caption,
      loading = _ref.loading,
      total = _ref.total,
      limit = _ref.limit,
      page = _ref.page,
      handlePageChange = _ref.handlePageChange,
      getTrProps = _ref.getTrProps,
      tableClassName = _ref.tableClassName,
      tableFlexBasis = _ref.tableFlexBasis,
      _ref$emptyStateIcon = _ref.emptyStateIcon,
      emptyStateIcon = _ref$emptyStateIcon === void 0 ? "search" : _ref$emptyStateIcon,
      _ref$emptyStateIconKi = _ref.emptyStateIconKit,
      emptyStateIconKit = _ref$emptyStateIconKi === void 0 ? "gt" : _ref$emptyStateIconKi,
      _ref$emptyStateMessag = _ref.emptyStateMessageText,
      emptyStateMessageText = _ref$emptyStateMessag === void 0 ? "Not available" : _ref$emptyStateMessag,
      _ref$emptyStateMessag2 = _ref.emptyStateMessageSubtext,
      emptyStateMessageSubtext = _ref$emptyStateMessag2 === void 0 ? "" : _ref$emptyStateMessag2,
      _ref$emptyStateAction = _ref.emptyStateActionLabel,
      emptyStateActionLabel = _ref$emptyStateAction === void 0 ? "" : _ref$emptyStateAction,
      handleEmptyStateAction = _ref.handleEmptyStateAction,
      emptyStateActionButton = _ref.emptyStateActionButton,
      _ref$scrollFetch = _ref.scrollFetch,
      scrollFetch = _ref$scrollFetch === void 0 ? function () {} : _ref$scrollFetch,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? false : _ref$scrollToTop;
  var bodyRef = useRef();
  useInfiniteScroll(scrollFetch, bodyRef.current);
  useEffect(function () {
    if (scrollToTop) {
      bodyRef.current.scrollTop = 0;
    }
  }, [scrollToTop]);

  var handlePageOnChange = function handlePageOnChange(page) {
    handlePageChange(page);
    bodyRef.current.scrollTop = 0;
  };

  var handleEmptyStateOnAction = function handleEmptyStateOnAction() {
    handleEmptyStateAction(window);
  };

  return /*#__PURE__*/React.createElement("table", {
    className: classNames("et--flex-table--wrapper", tableClassName)
  }, /*#__PURE__*/React.createElement("caption", {
    className: "et--visually-hidden"
  }, caption), /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      overflowY: "auto"
    },
    className: "et--flex-table--header-row"
  }, columns.map(function (_ref2) {
    var width = _ref2.width,
        header = _ref2.header,
        headerClassName = _ref2.headerClassName,
        headerStyle = _ref2.headerStyle;
    return /*#__PURE__*/React.createElement("th", {
      key: uuid(),
      style: _objectSpread({
        minWidth: width
      }, headerStyle),
      className: classNames("et--flex-table--header-cell", headerClassName)
    }, header);
  }))), /*#__PURE__*/React.createElement("tbody", {
    ref: bodyRef,
    style: {
      overflowY: "auto",
      minHeight: loading ? "10vh" : "0",
      flexBasis: tableFlexBasis
    },
    className: "et--flex-table--body"
  }, loading ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Loading, null))) : !data.length ? /*#__PURE__*/React.createElement("tr", {
    className: "et--flex-table--empty-state"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(EmptyStateMessage, {
    icon: emptyStateIcon,
    iconKit: emptyStateIconKit,
    text: emptyStateMessageText,
    subtext: emptyStateMessageSubtext,
    actionLabel: emptyStateActionLabel,
    onAction: handleEmptyStateOnAction,
    actionButton: emptyStateActionButton
  }))) : data.map(function (datum, idx) {
    var tr_props = typeof getTrProps === "function" ? getTrProps(datum, idx) : {};
    return /*#__PURE__*/React.createElement(TableRow, _extends({
      key: uuid()
    }, tr_props), columns.map(function (col) {
      var Cell = col.Cell;
      return Cell ? /*#__PURE__*/React.createElement(Cell, _extends({
        key: uuid(),
        className: classNames("et--flex-table--cell", col.cellClassName)
      }, datum)) : /*#__PURE__*/React.createElement("td", {
        key: uuid(),
        style: {
          minWidth: col.width
        },
        className: classNames("et--flex-table--cell", col.cellClassName)
      }, typeof col.accessor === "function" ? col.accessor(datum, idx) : datum[col.accessor]);
    }));
  })), typeof handlePageChange === "function" && total > limit && /*#__PURE__*/React.createElement("tfoot", {
    className: "et--flex-table--pagination"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "et--flex-table--pagination-holder"
  }, /*#__PURE__*/React.createElement(Pagination, {
    page: page,
    total: Math.ceil(total / limit),
    onChange: handlePageOnChange
  })))));
};

Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  caption: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  total: PropTypes.number,
  limit: PropTypes.number,
  page: PropTypes.number,
  handlePageChange: PropTypes.func,
  getTrProps: PropTypes.func,
  emptyStateIcon: PropTypes.string,
  emptyStateIconKit: PropTypes.string,
  emptyStateMessageText: PropTypes.string,
  emptyStateMessageSubtext: PropTypes.string,
  emptyStateActionLabel: PropTypes.string,
  handleEmptyStateAction: PropTypes.func,
  emptyStateActionButton: PropTypes.object,
  disableScrollTopOnPageChange: PropTypes.bool,
  tableFlexBasis: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tableClassName: PropTypes.string,
  scrollFetch: PropTypes.func,
  scrollToTop: PropTypes.bool
};
export default Table;